import { Link } from 'react-router-dom';
import { BookOpen } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-blue-950 text-white py-10 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col md:flex-row items-start justify-between gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 bg-yellow-500 rounded-lg flex items-center justify-center"><BookOpen size={16} className="text-blue-950"/></div>
              <span className="font-bold text-lg">LawOC</span>
            </div>
            <p className="text-blue-300 text-sm max-w-xs">Cambodia's premier legal research platform. Search, read, and download Cambodian law documents.</p>
          </div>
          <div className="grid grid-cols-2 gap-8 text-sm">
            <div>
              <h4 className="font-semibold text-yellow-400 mb-3">Platform</h4>
              {[['Home','/'],['Search','/search'],['AI Chat','/chat'],['News','/blog'],['Pricing','/pricing']].map(([l,t])=>(
                <Link key={t} to={t} className="block text-blue-300 hover:text-white py-0.5 transition">{l}</Link>
              ))}
            </div>
            <div>
              <h4 className="font-semibold text-yellow-400 mb-3">Legal</h4>
              {['Privacy Policy','Terms of Service','Contact Us','About LawOC'].map(l=>(
                <span key={l} className="block text-blue-300 py-0.5 cursor-default">{l}</span>
              ))}
            </div>
          </div>
        </div>
        <div className="border-t border-blue-900 pt-6 text-center text-xs text-blue-400">
          © {new Date().getFullYear()} Law of Cambodia (LawOC) · Cambodia Legal Research Platform · All rights reserved
        </div>
      </div>
    </footer>
  );
}
